(function () {
  const APP_SELECTOR = '[data-bundle-app]';

  function parseVariants(app) {
    const script = app.querySelector(
      '[data-bundle-variants]'
    );

    if (!script) return [];

    try {
      return JSON.parse(
        script.textContent || '[]'
      );
    } catch (error) {
      console.error(
        '[Bundle App] Invalid variants JSON.',
        error
      );

      return [];
    }
  }

  function getProductForm(app) {
    const formId =
      app.dataset.productFormId;

    if (!formId) return null;

    return document.getElementById(formId);
  }

  function getMainVariantId(app) {
    const form = getProductForm(app);

    const input = form?.querySelector(
      'input[name="id"]'
    );

    return input?.value
      ? Number(input.value)
      : null;
  }

  function getVariantById(
    variants,
    variantId
  ) {
    return (
      variants.find(
        (variant) =>
          Number(variant.id) ===
          Number(variantId)
      ) || null
    );
  }

  function updateMainVariantDisplay(app) {
    const variants = parseVariants(app);

    const variantId =
      getMainVariantId(app);

    const variant = getVariantById(
      variants,
      variantId
    );

    if (!variant) return;

    app
      .querySelectorAll(
        '[data-bundle-main-variant-text]'
      )
      .forEach((element) => {
        element.textContent =
          variant.title;
      });
  }

  function copyMainVariantToExtraPairs(
    app
  ) {
    const variants = parseVariants(app);

    const variantId =
      getMainVariantId(app);

    const variant = getVariantById(
      variants,
      variantId
    );

    if (
      !variant ||
      !Array.isArray(variant.options)
    ) {
      return;
    }

    /*
     * Only set automatically when
     * inicializamos o componente.
     *
     * The customer can change it afterwards
     * Pair #2 e Pair #3 livremente.
     */
    app
      .querySelectorAll(
        '[data-bundle-option]'
      )
      .forEach((select) => {
        const optionIndex = Number(
          select.dataset.optionIndex
        );

        const value =
          variant.options[optionIndex];

        if (value === undefined) return;

        const optionExists =
          Array.from(select.options).some(
            (option) =>
              option.value === value
          );

        if (optionExists) {
          select.value = value;
        }
      });
  }

  function selectTier(app, tier) {
    const normalizedTier =
      String(tier || '1');

    app
      .querySelectorAll(
        '[data-bundle-tier]'
      )
      .forEach((offer) => {
        const isSelected =
          offer.dataset.bundleTier ===
          normalizedTier;

        offer.classList.toggle(
          'is-selected',
          isSelected
        );

        const radio =
          offer.querySelector(
            '.bundle-app__radio'
          );

        if (radio) {
          radio.checked = isSelected;
        }
      });

    app.dataset.selectedTier =
      normalizedTier;
  }

  function initializeBundleApp(app) {
    if (
      app.dataset.bundleInitialized ===
      'true'
    ) {
      return;
    }

    app.dataset.bundleInitialized =
      'true';

    const defaultTier =
      app.dataset.defaultTier || '2';

    selectTier(app, defaultTier);

    updateMainVariantDisplay(app);

    copyMainVariantToExtraPairs(app);

    app.addEventListener(
      'change',
      (event) => {
        const radio =
          event.target.closest(
            '.bundle-app__radio'
          );

        if (radio) {
          selectTier(
            app,
            radio.value
          );
        }
      }
    );

    app.addEventListener(
      'click',
      (event) => {
        const offer =
          event.target.closest(
            '[data-bundle-tier]'
          );

        if (!offer) return;

        if (
          event.target.closest(
            'select'
          )
        ) {
          return;
        }

        selectTier(
          app,
          offer.dataset.bundleTier
        );
      }
    );

    /*
     * O picker principal do produto
     * pode alterar o input name="id".
     * Observamos esse input para manter
     * o Pair #1 atualizado.
     */
    const form = getProductForm(app);

    const variantInput =
      form?.querySelector(
        'input[name="id"]'
      );

    if (variantInput) {
      const observer =
        new MutationObserver(() => {
          updateMainVariantDisplay(app);
        });

      observer.observe(variantInput, {
        attributes: true,
        attributeFilter: ['value']
      });

      variantInput.addEventListener(
        'change',
        () => {
          updateMainVariantDisplay(app);
        }
      );
    }
  }

  function initializeAll() {
    document
      .querySelectorAll(APP_SELECTOR)
      .forEach(
        initializeBundleApp
      );
  }

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      initializeAll
    );
  } else {
    initializeAll();
  }

  document.addEventListener(
    'shopify:section:load',
    initializeAll
  );
})();